/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  DAYS, INTERVAL_COLORS, MODALS, SVG_ICONS, DAYS_SHORT,
} from '../../constants';

import {
  getModalData, checkPermisson,
} from '../../selectors/common';
import SVGComponent from '../../components/SVG/SVGComponent';
import {
  getTempLink,
} from '../../selectors/autobooking';
import { scrollTo } from '../../utils/common';
import AutoBookingModals from './AutoBookingModals';
import TennisIntervalDetailsRow from './Tennis/IntervalDetailsRow';
import SoccerIntervalDetailsRow from './Soccer/IntervalDetailsRow';
import { aSetOpenModal } from '../../reducers/common';
import { aClearIntervalErrors, aClearTempLink } from '../../reducers/autobooking';

const elementId = 'selectedDay';

const mapToProps = (state) => ({
  modalData: getModalData(state),
  getTempLink: getTempLink(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  clearIntervalErrors: (payload) => dispatch(aClearIntervalErrors(payload)),
  clearTempLink: (payload) => dispatch(aClearTempLink(payload)),
});

class AutoBooking extends Component {
  constructor() {
    super();
    this.state = {
      selectedDay: null,
    };
    this.colorIndex = 0;
    this.days = new Array(7).fill(); // create an empty array to represent days in a week
    const date = new Date();
    date.setHours('00', '23', '00');
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedDay !== this.state.selectedDay) {
      scrollTo(elementId);
    }
  }

  componentWillUnmount() {
    this.props.clearTempLink();
  }

  // eslint-disable-next-line
  getColor = (numOfIntervals, checkLastDay, i, interval, sameInterval) => {
    const numOfColors = INTERVAL_COLORS.length;
    if (checkLastDay && i === numOfIntervals - 1) {
      // IN A CASE WHEN LAST INTERVAL ON SUNDAY IS THE SAME INTERVAL FROM MONDAY
      if (this.props.weekSummary[1][0] && this.props.weekSummary[1][0].id === interval.id) {
        this.colorIndex = 1;
      } else {
        // IN A CASE IS NOT THE SAME INTERVAL SKIP COLOR 1
        this.colorIndex = (this.colorIndex + 1) % numOfColors;
        this.colorIndex = this.colorIndex === 1 ? 2 : this.colorIndex;
        this.colorIndex = this.colorIndex === this.firstColorOnLastDay
          ? (this.firstColorOnLastDay + 1) % numOfColors
          : this.colorIndex;
      }
    } else {
      if (checkLastDay && i === numOfIntervals - 2 && this.colorIndex === 0) {
        // IN A CASE WHEN LAST INTERVAL ON SUNDAY IS THE SAME INTERVAL FROM MONDAY AND
        // THE INTERVAL IN FRONT ALREADY HAVE THE SAME COLOR (1) LIKE FIRST INTERVAL
        this.colorIndex = 2;
      } else if (!(sameInterval && i === 0)) {
        // CHANGE COLOR ONLY IN CASE THE FIRST INTERVAL IS NOT THE SAME INTERVAL FROM PREVIOUS DAY
        this.colorIndex = (this.colorIndex + 1) % numOfColors;
      }
      if (((numOfIntervals % (numOfColors + 1) === 0
        && i === numOfIntervals - 1 && !checkLastDay)
        || (checkLastDay && this.colorIndex === 1 && i === 0 && !sameInterval)
      )) {
        //  IN A CASE WHERE THE FIRST INTERVAL WILL
        // HAVE THE SAME COLOR LIKE LAST INTERVAL ON THE SAME DAY
        this.colorIndex = this.colorIndex + 2 >= numOfColors
          ? this.colorIndex + 2 - numOfColors : this.colorIndex + 2;
      }
      if (checkLastDay && i === 0) {
        this.firstColorOnLastDay = this.colorIndex;
      }
    }
    return INTERVAL_COLORS[this.colorIndex];
  };

  renderIntervals = (day, previousDay, checkLastDay) => {
    let prevTime = new Date();
    prevTime.setHours(0, 0, 0);
    const todayIntervals = this.props.weekSummary[day];
    const prevDayIntervals = previousDay && this.props.weekSummary[previousDay];
    // CHECK IF INTERVAL IS THE SAME LIKE PREVIOUS ONE.
    const sameInterval = prevDayIntervals && prevDayIntervals[prevDayIntervals.length - 1]
      && todayIntervals[0] && todayIntervals[0].id
      === prevDayIntervals[prevDayIntervals.length - 1].id;
    return todayIntervals && todayIntervals.map((interval, i) => {
      const color = this.getColor(todayIntervals.length, checkLastDay, i, interval, sameInterval);
      const startTime = new Date();
      let time = interval.start.split(':');
      startTime.setHours(time[0], time[1], 0);
      const endTime = new Date();
      time = interval.end.split(':');
      endTime.setHours(time[0], time[1], 0);
      const gapDiff = parseInt((startTime.getTime() - prevTime.getTime()) / 1000 / 60);
      const gapWidth = (((gapDiff / 60) * 100) / 24).toFixed(2);
      let intervalWidth = parseInt((endTime.getTime() - startTime.getTime()) / 1000 / 60);
      intervalWidth = (((intervalWidth / 60) * 100) / 24).toFixed(2);
      prevTime = endTime;
      return (
        <React.Fragment key={`${i}-interval`}>
          <div
            className="booking__row-interval-gap"
            style={{ width: `${gapWidth}%` }}
          />
          <div
            className={`booking__row-time-interval ${color} interval-x`}
            style={{ width: `${intervalWidth}%` }}
            color={color}
          >
            {interval.count}
          </div>
        </React.Fragment>
      );
    });
  };

  openIntervalModal = () => {
    this.setState({
      selectedDay: null,
    });
    this.props.setOpenModal({
      modal: MODALS.AUTO_BOOKING,
    });
  };

  editInterval = (interval) => {
    const selectedInterval = this.props.intervals.find((x) => x.intervalId === interval.id);
    this.props.setOpenModal({
      modal: MODALS.AUTO_BOOKING,
      modalData: {
        selectedInterval,
        edit: true,
      },
    });
  };

  closeIntervalModal = () => {
    this.props.clearIntervalErrors();
    this.props.setOpenModal({
      modal: '',
    });
  };

  forceNavigateWithoutSave = () => {
    this.closeIntervalModal();
    this.props.navigate(this.props.getTempLink);
  };

  selectADay = (day) => {
    this.setState({
      selectedDay: this.state.selectedDay === day + 1 ? null : day + 1,
    });
  };

  renderTeams = (event, league) => (
    event.preferredTeams && event.preferredTeams.map((t, i) => {
      const team = league.teams.find((tt) => tt.id === t);
      return (
        team && `${team.name}${i === event.preferredTeams - 1 ? '' : ', '}`
      );
    })
  );

  removeIntervalPrompt = (interval) => {
    const selectedInterval = this.props.intervals.find((x) => x.intervalId === interval.id);
    this.props.setOpenModal({
      modal: MODALS.DELETE_INTERVAL,
      modalData: {
        selectedInterval,
        interval,
      },
    });
  };

  renderSaveIntervalPrompt = () => {
    this.props.setOpenModal({
      modal: MODALS.SAVE_INTERVAL,
    });
  };

  getCombinedWeekAsArr = () => {
    if (this.props.weekSummary) {
      const combinedWeek = [];
      const weekSummaryArr = Object.values(this.props.weekSummary);
      for (let i = 0; i < weekSummaryArr.length; i += 1) {
        combinedWeek.push(...weekSummaryArr[i]);
      }
      return combinedWeek;
    }
    return null;
  };

  renderOneIntervalDetails = (interval, previousDay, nextDay) => {
    const selectedInterval = this.props.intervals.find((x) => x.intervalId === interval.id);
    const day = selectedInterval
      ? `${previousDay ? DAYS_SHORT[previousDay] : ''} ${selectedInterval.startTime} - ${selectedInterval.endTime} ${nextDay ? DAYS_SHORT[nextDay] : ''}`
      : '';

    const combinedWeek = this.getCombinedWeekAsArr();
    const selectedIntervalIdx = combinedWeek.findIndex((l) => l.id === interval.id);
    const intervalNodes = document.querySelectorAll('.interval-x');
    const color = intervalNodes[selectedIntervalIdx]?.getAttribute('color');

    return selectedInterval && (
      <div className="interval__item-wrap" key={interval.id}>
        <div className={`interval__item ${color}`}>
          <span>{day}</span>
          {this.props.hasPermissionToUpdate
            && (
              <div className="interval__item-btn">
                <SVGComponent
                  src={`${SVG_ICONS.utility}#edit`}
                  className="icon-xs m-r-10"
                  onClick={this.editInterval.bind(this, interval)}
                />
                <SVGComponent
                  src={`${SVG_ICONS.utility}#bin`}
                  className="icon-xs"
                  onClick={this.removeIntervalPrompt.bind(this, interval)}
                />
              </div>
            )}
        </div>
        <div className="interval__detail">
          {selectedInterval.events.map((event) => (
            this.props.isTennis
              ? (
                <TennisIntervalDetailsRow
                  key={event.competitionId}
                  competitions={this.props.leagues}
                  event={event}
                />
              )
              : (
                <SoccerIntervalDetailsRow
                  key={event.leagueId}
                  leagues={this.props.leagues}
                  event={event}
                  renderTeams={this.renderTeams}
                />
              )
          ))}
        </div>
      </div>
    );
  };

  renderDayDetails = () => {
    if (this.props.weekSummary[this.state.selectedDay]) {
      const intervals = [];
      const currentIntervals = this.props.weekSummary[this.state.selectedDay];
      const previousDay = this.state.selectedDay === 1 ? 7 : this.state.selectedDay - 1;
      const nextDay = this.state.selectedDay === 7 ? 1 : this.state.selectedDay + 1;

      const previousIntervals = this.props.weekSummary[previousDay];
      const showPreviousInterval = previousIntervals
        && previousIntervals[previousIntervals.length - 1] && currentIntervals[0]
        && previousIntervals[previousIntervals.length - 1].id
        === currentIntervals[0].id;

      const nextIntervals = this.props.weekSummary[nextDay];
      if (showPreviousInterval) {
        intervals.push(
          this.renderOneIntervalDetails(
            previousIntervals[previousIntervals.length - 1], previousDay, false,
          ),
        );
      }
      if (currentIntervals) {
        currentIntervals.map((interval, i) => {
          if (showPreviousInterval && i === 0) return false;
          if (i === currentIntervals.length - 1 && nextIntervals && nextIntervals[0]
            && nextIntervals[0].id === interval.id) {
            intervals.push(
              this.renderOneIntervalDetails(interval, false, nextDay),
            );
            return false;
          }
          intervals.push(
            this.renderOneIntervalDetails(interval, false, false),
          );
          return true;
        });
      }
      return intervals.map((i) => i);
    }
    return null;
  };

  addInterval = (modalData) => {
    modalData.events.map((event) => {
      if (event.preferredTeams) {
        event.preferredTeams = event.preferredTeams.map((t) => t.id);
      }
    });
    const startTime = `${modalData.startHour}:${modalData.startMin}`;
    const endTime = `${modalData.endHour}:${modalData.endMin}`;
    this.props.addNewInterval({
      startTime,
      startDay: modalData.startDay,
      endTime,
      endDay: modalData.endDay,
      events: modalData.events,
      intervalId: modalData.intervalId,
    });
  };

  handleRemoveInterval = (intervalId) => {
    this.props.deleteInterval({ intervalId });
    this.closeIntervalModal();
  };

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    this.colorIndex = 0;
    return (
      <>
        <div className="booking m-t-30">
          <div className="booking__head">
            <span>Select a Day</span>
            {this.props.hasPermissionToUpdate
              && (
                <div
                  id="addIntervalBtn1_AutobookingPage"
                  className="booking__head-btn"
                  onClick={this.openIntervalModal}
                >
                  <span>+</span>
                  <span className="tooltip">Add new interval</span>
                </div>
              )}
          </div>
          <div className="booking__wrap">
            <div className="booking__scale">
              <span />
              <span />
              <span />
              <span />
              <div className="scale-0">00:00</div>
              <div className="scale-1">06:00</div>
              <div className="scale-2">12:00</div>
              <div className="scale-3">18:00</div>
              <div className="scale-4">23:59</div>
            </div>
            {this.props.intervals && this.props.weekSummary
              && this.days.map((day, i) => (
                <div
                  className={`booking__row ${this.state.selectedDay === i + 1 ? 'selected' : ''}
                 ${this.props.editedDays.findIndex((x) => x === i + 1) !== -1 ? 'edited' : ''}`}
                  key={i}
                  onClick={this.selectADay.bind(this, i)}
                >
                  <div className="booking__row-day">{DAYS[i + 1]}</div>
                  <div className="booking__row-time">
                    {this.renderIntervals(i + 1, i, this.days.length - 1 === i)}
                  </div>
                </div>
              ))}
          </div>
        </div>
        {this.props.hasPermissionToUpdate
          && (
            <div className="m-t-30 p-r-30 text-right">
              <button
                id="cancel_AutobookingPage"
                type="button"
                className="btn btn-secondary"
                onClick={this.props.clearChanges}
              >
                Cancel
              </button>
              <button
                id="save_AutobookingPage"
                type="button"
                className="btn btn-primary m-l-10"
                onClick={this.renderSaveIntervalPrompt}
              >
                Save
              </button>
            </div>
          )}
        {this.state.selectedDay !== null && this.props.intervals && this.props.weekSummary
          && (
            <div className="interval m-t-30" id={elementId}>
              <div className="interval__head-wrap">
                {this.props.hasPermissionToUpdate
                  && (
                    <div id="addIntervalBtn2_AutobookingPage" className="interval__head-btn clr-b" onClick={this.openIntervalModal}>
                      <span>+</span>
                      {' '}
                      <span className="tooltip">Add new interval</span>
                    </div>
                  )}
                <div className="interval__head">{DAYS[this.state.selectedDay]}</div>
              </div>
              <div className="interval__content">
                {this.renderDayDetails()}
              </div>
            </div>
          )}
        <AutoBookingModals
          leagues={this.props.leagues}
          closeIntervalModal={this.closeIntervalModal}
          addInterval={this.addInterval}
          modalData={this.props.modalData}
          handleRemoveInterval={this.handleRemoveInterval}
          intervals={this.props.intervals}
          forceNavigateWithoutSave={this.forceNavigateWithoutSave}
          saveChanges={this.props.saveChanges}
          isTennis={this.props.isTennis}
        />
      </>

    );
  }
}

export default connect(mapToProps, actionsToProps)(AutoBooking);
